/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect } from "react";
import { Button, useNavItem } from "@restart/ui";
import { Tooltip as ReactTooltip } from 'react-tooltip';

const Tab = ({ eventKey, tooltip, ...props }) => {
  const [navItemProps, meta] = useNavItem({
    key: eventKey
  });

  const tabId = navItemProps.id;

  useEffect(() => {
    if (meta.isActive) {
      const tabsContainer = document.getElementById(tabId).parentNode;
      tabsContainer.style.setProperty('--tab-index', eventKey - 1);
    }
  }, [meta.isActive, tabId]);

  return (
    <>
      <Button
        {...props}
        {...navItemProps}
        className="figma-tab"
        data-for={tabId}
        data-tip
      />
      {tooltip && (
        <ReactTooltip id={tabId} place="bottom">
          <center><span>{tooltip}</span></center>
        </ReactTooltip>
      )}
    </>
  );
};

export default Tab;
